import service from './index';
import sellerProductBff from './sellerProductBff';
export default {
  async getByBarcode (barcode, options = {}) {
    const response = await service.get(`products/single/${barcode}`, {
      ...options,
      params: {
        page: 0,
        pageSize: 1,
      },
      hideErrorMessage: true,
    });
    return response;
  },
  async getProductGroupViaName (params) {
    Object.keys(params).forEach((param) => {
      if (params[param] === null) {
        delete params[param];
      }
    });
    const reqParams = new URLSearchParams(params);
    reqParams.delete('categoryIds');
    reqParams.delete('brandIds');
    if (params.categoryIds && params.categoryIds.length) {
      params.categoryIds.forEach((item) => {
        reqParams.append('categoryIds', item);
      });
    }
    if (params.brandIds && params.brandIds.length) {
      params.brandIds.forEach((item) => {
        reqParams.append('brandIds', item);
      });
    }

    const response = await service.get('products/single/by-name', {
      params: reqParams,
      hideErrorMessage: true,
    });
    return response;
  },
  async getProductViaContentId (contentId, params) {
    const response = await service.get(`products/single/by-content-id/${contentId}`, {
      params,
      hideErrorMessage: true,
    });
    return response;
  },
  async getProductBuyBoxPrice (variantId) {
    const response = await service.get(
      `/products/buy-box-price/by-variant?variantId=${variantId}`,
      {
        hideSpinner: true,
      },
    );
    return response;
  },
  async createProduct (data) {
    const response = await service.post('products/single/create', {
      items: [data],
    });
    return response;
  },
  async createProductNotExisting (data) {
    const response = await service.post('/products/single/not-existing', {
      items: data,
    }, {
      hideSpinner: true,
    });
    return response;
  },
  async getProductImagePath (fileNames) {
    const response = await service.get(`/products/single/image-upload-url?fileName=${fileNames}`, {
      hideSpinner: true,
    });
    return response;
  },
  async getBadgePricesById (productId, options = {}) {
    const response = await service.get(`/products/${productId}/price-limit`, options);
    return response.barcodePrices;
  },
  async getBadgePricesByVariantId (variantId) {
    const response = await service.get(`/price-limits/${variantId}`);
    return response;
  },
  async getBuyboxContents (data, options = {}) {
    const response = await sellerProductBff.post('buybox/contents', data, {
      hideSpinner: true,
      ...options,
    });
    return response;
  },

};
